module.exports = __webpack_public_path__ + "static/media/pen3287ccf0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/pen.svg
// module id = 1494
// module chunks = 0